import React, { useState, useEffect } from "react";
import { Button, Form, FormGroup, Label, Input } from "reactstrap";
import { useLocation } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";

const ActivateOld = () => {
    const location = useLocation();
    const [token, setToken] = useState("");
    const [phone, setPhone] = useState("");
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [email, setEmail] = useState("");

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const tokenParam = params.get("token");
        const firstNameParam = null;
        const lastNameParam = null;
        const emailParam = null;
        console.log("location.search, useEffect:", location.search);
        if (tokenParam) setToken(tokenParam);
        if (firstNameParam) setFirstName(firstNameParam);
        if (lastNameParam) setLastName(lastNameParam);
        if (emailParam) setEmail(emailParam);
    }, [location.search]);

    const { getAccessTokenSilently, isAuthenticated } = useAuth0();

    useEffect(() => {
        console.log("isAuthenticated, useEffect:", isAuthenticated);
        if (isAuthenticated) {
            getAccessTokenSilently().then(token => {
                console.log("Auth0 Access Token:", token);
                const parsedToken = parseJwt(token);
                setEmail(parsedToken["https://carfax.com/b2b-user"]?.email || "");
            });
        }
    }, [getAccessTokenSilently, isAuthenticated]);

    function parseJwt (token) {
        var base64Url = token.split('.')[1];
        var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        var jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));

        return JSON.parse(jsonPayload);
    }


    const handleSubmit = (e) => {
        e.preventDefault();
        console.log("Token:", token, "Phone:", phone, "First Name:", firstName, "Last Name:", lastName, "Email:", email);
    };

    return (
        <Form onSubmit={handleSubmit}>
        <Input
            type="hidden"
            name="token"
            id="token"
            value={token}
            readOnly
        />
        <FormGroup>
            <Label for="email">Email</Label>
            <Input
                type="email"
                name="email"
                id="email"
                value={email}
                disabled
            />
        </FormGroup>
        <FormGroup>
            <Label for="firstName">First Name</Label>
            <Input
                type="text"
                name="firstName"
                id="firstName"
                value={firstName}
                onChange={e => setFirstName(e.target.value)}
                required
            />
        </FormGroup>
        <FormGroup>
            <Label for="lastName">Last Name</Label>
            <Input
                type="text"
                name="lastName"
                id="lastName"
                value={lastName}
                onChange={e => setLastName(e.target.value)}
                required
            />
        </FormGroup>
        <FormGroup>
            <Label for="phone">Phone Number</Label>
            <Input
                type="tel"
                name="phone"
                id="phone"
                value={phone}
                onChange={e => setPhone(e.target.value)}
                required
            />
        </FormGroup>
        <Button type="submit" color="primary">Activate</Button>
    </Form>
    );
};

export default ActivateOld;